import { connect } from 'react-redux';
import storage from '../../../../../lib/Storage';
import { findStorageType } from '../../../../../lib/Auth';
import SmsConversationScreen from '../components/SmsConversationScreen';
import {
  updateSmsConversationFromSocket,
  markAsReadSmsMessages,
} from '../../../../../state/modules/smsConversations/actions';
import {
  addNewSmsMessage,
  loadSmsMessages,
} from '../../../../../state/modules/smsMessages/actions';

const mapStateToProps = (state, ownProps) => {
  const tz = state.userAccount.getIn(
    ['data', 'timezone'],
    'America/Los_Angeles'
  );

  return {
    tz,
    accessTabs: storage.get(findStorageType(), 'partnershipData')
      ?.access_tabs_in_app,
    deletedConversationId: state.smsConversations.get('deletedConversationId'),
    partnershipId: storage.get(findStorageType(), 'partnershipId'),
    profileId: state.session.get('profileId'),
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateConversation: (
      partnershipId,
      profileId,
      smsConversation,
      smsMessage,
      isViewingConversation,
      isSentByMe
    ) => {
      dispatch(
        updateSmsConversationFromSocket(
          partnershipId,
          profileId,
          smsConversation,
          smsMessage,
          isViewingConversation,
          isSentByMe
        )
      );
    },
    addMessage: (partnershipId, smsConversationId, smsMessage) => {
      dispatch(addNewSmsMessage(partnershipId, smsConversationId, smsMessage));
    },
    reloadMessages: (partnershipId, smsConversationId, page, limit, order) => {
      dispatch(
        loadSmsMessages(partnershipId, smsConversationId, page, limit, order)
      );
    },
    markAsRead: (partnershipId, smsConversationId, data) => {
      dispatch(markAsReadSmsMessages(partnershipId, smsConversationId, data));
    },
  };
};

const SmsConversationScreenContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(SmsConversationScreen);

export default SmsConversationScreenContainer;
